import { useSelector } from 'react-redux'

import { selectScid } from 'store/college'
import { useScid as useGuaranteedScid } from 'store/college/hooks'

export default () => useSelector(selectScid)
export { useGuaranteedScid }
